import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { AuthHttp } from 'angular2-jwt';
import { ResponseContentType, Response } from '@angular/http';
import { raceStatic } from 'rxjs/operator/race';

@Injectable()
export class CourseriddenService {
  // private http: Http,
  constructor(private authHttp: AuthHttp) { }

  getAllCoursesRidden() {
    return this.authHttp.get("/api/coursesridden").map(res => res.json());
  }

  getCourseRidden(id: number) {
    return this.authHttp.get('/api/coursesridden/' + id).map(res => res.json());
  }

  getAllUsersCoursesRidden(id: number, year: number) {
    return this.authHttp.get('/api/coursesridden/user/' + id+'/'+year).map(res => res.json());
  }

  update(courseRidden: any) {
    return this.authHttp.put('/api/coursesridden/' + courseRidden.id, courseRidden).map(res => res.json());
  }

  create(courseRidden: any) {
    return this.authHttp.post('/api/coursesridden/', courseRidden).map(res => res.json());
  }

  delete(id: number) {
    return this.authHttp.delete('/api/coursesridden/' + id).map(res => res.json());
  }

  downloadAllUsersExcel(year:number) {
    return this.authHttp.get('/api/coursesridden/generateXlsxAllUsers/'+year, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }

  getYearOverview() {
    return this.authHttp.get('/api/coursesridden/getYearOverviewPerGroup').map(res => res.json());
  }
  
  getYearOverviewYear(year: number) {
    return this.authHttp.get('/api/coursesridden/getYearOverviewPerGroup/'+year).map(res => res.json());
  }

  getCountOfMembersPerGroup(id: number, year:number){
    return this.authHttp.get('/api/coursesridden/groupswithYear/'+id+"/"+year).map(res => res.json());
  }

  downloadCoursesRiddenPerGroup(id: number, year:number){
    return this.authHttp.get('/api/coursesridden/generateXlsxUsersGroup/'+id+"/"+year ,{ responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }

  downloadCoursesRiddenOverview(year:number){
    return this.authHttp.get('/api/coursesridden/downloadCoursesRiddenOverview/'+year, {responseType: ResponseContentType.Blob}).map((res: Response )=> {
      return res;
    });
  }

  downloadYearOverviewPerGroup (year: number){
    return this.authHttp.get('/api/coursesridden/getYearOverviewPerGroupXlsx/'+year, {responseType: ResponseContentType.Blob}).map((res: Response )=> {
      return res;
    });
  }

  getYearsForMember(id: number){
    return this.authHttp.get('api/coursesridden/user/yearsavailable/'+id).map(res => res.json());
  }

  getAllYears(){
    return this.authHttp.get('api/coursesridden/user/yearsavailable').map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/courseridden.service.ts